import { useQuery } from '@tanstack/react-query'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { request } from 'src/editor/shared/utils/request'

interface UserData {
  id: string
  firstName: string
  lastName: string
  dashboardLocale: PageLocaleEnum
}

const fetchUserData = async (): Promise<UserData> => {
  const response = await request.get('/api/dashboard/user/user-data')
  return response.data
}

// Hook to retrieve user data
export const useUser = () => {
  return useQuery<UserData, Error>({
    queryKey: ['userData'],
    queryFn: fetchUserData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  })
}
